"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserMFAFactorResource = exports.MFAFactor = exports.MFAFactorState = exports.DeveloperInviteResource = exports.DeveloperInvite = exports.DeveloperInviteStatus = exports.UserResource = exports.User = exports.UserOrgAccess = exports.AppResource = exports.App = exports.ProjectFeatureFlags = exports.VCS_MODE = exports.OrganizationResource = exports.Organization = exports.BUSINESS_REGION = void 0;
const source = __importStar(require("@journeyapps-platform/types-source-service"));
const codecs = __importStar(require("@journeyapps-platform/micro-codecs"));
const t = __importStar(require("ts-codec"));
var BUSINESS_REGION;
(function (BUSINESS_REGION) {
    BUSINESS_REGION["ZA"] = "za";
    BUSINESS_REGION["US"] = "us";
})(BUSINESS_REGION || (exports.BUSINESS_REGION = BUSINESS_REGION = {}));
exports.Organization = t.object({
    label: t.string,
    locked: t.boolean.optional(),
    business_customer_code: t.string.optional(),
    business_customer_region: t.Enum(BUSINESS_REGION).optional()
});
exports.OrganizationResource = exports.Organization.and(codecs.ResourceId);
var VCS_MODE;
(function (VCS_MODE) {
    VCS_MODE["ADVANCED"] = "ADVANCED";
    VCS_MODE["BASIC"] = "BASIC";
})(VCS_MODE || (exports.VCS_MODE = VCS_MODE = {}));
var ProjectFeatureFlags;
(function (ProjectFeatureFlags) {
    ProjectFeatureFlags["APP"] = "app";
    ProjectFeatureFlags["POWERSYNC"] = "powersync";
    // maybe later: 'cloudcode', 'backend'
})(ProjectFeatureFlags || (exports.ProjectFeatureFlags = ProjectFeatureFlags = {}));
exports.App = t.object({
    name: t.string,
    org_id: t.string,
    auth_scope_id: t.string.optional(),
    vcs_mode: t.Enum(VCS_MODE).optional(),
    source: source.SourceMetadata.optional(),
    region: t.string,
    features: t.array(t.Enum(ProjectFeatureFlags)),
    trial: t.boolean.optional(),
    locked: t.boolean.optional(),
    trial_expiry: t.string.optional()
});
exports.AppResource = exports.App.and(codecs.ResourceId);
var UserOrgAccess;
(function (UserOrgAccess) {
    UserOrgAccess["DEVELOPER"] = "developer";
    UserOrgAccess["OWNER"] = "owner";
})(UserOrgAccess || (exports.UserOrgAccess = UserOrgAccess = {}));
exports.User = t.object({
    email: t.string,
    org_id: t.string,
    name: t.string.optional(),
    phone_number: t.string.optional(),
    signup_complete: t.boolean.optional(),
    onboarding_token: t.string.optional()
});
exports.UserResource = exports.User.and(codecs.ResourceId);
var DeveloperInviteStatus;
(function (DeveloperInviteStatus) {
    DeveloperInviteStatus["PENDING"] = "pending";
    DeveloperInviteStatus["ACCEPTED"] = "accepted";
    DeveloperInviteStatus["DECLINED"] = "declined";
})(DeveloperInviteStatus || (exports.DeveloperInviteStatus = DeveloperInviteStatus = {}));
exports.DeveloperInvite = t.object({
    status: t.Enum(DeveloperInviteStatus),
    responded_at: t.string,
    metadata: t.object({
        user_name: t.string.optional(),
        org_name: t.string.optional(),
        email: t.string.optional(),
        role_names: t.array(t.string).optional()
    }),
    org_id: t.string,
    user_id: t.string,
    requested_role_ids: t.array(t.string)
});
exports.DeveloperInviteResource = exports.DeveloperInvite.and(codecs.ResourceId);
var MFAFactorState;
(function (MFAFactorState) {
    MFAFactorState["ACTIVE"] = "active";
    MFAFactorState["DISABLED"] = "disabled";
    MFAFactorState["PENDING"] = "pending";
})(MFAFactorState || (exports.MFAFactorState = MFAFactorState = {}));
var MFAFactor;
(function (MFAFactor) {
    MFAFactor["SMS"] = "sms";
    MFAFactor["TOTP"] = "totp";
})(MFAFactor || (exports.MFAFactor = MFAFactor = {}));
exports.UserMFAFactorResource = t.object({
    id: t.string,
    created_at: t.string,
    updated_at: t.string,
    deleted_at: t.string,
    state: t.Enum(MFAFactorState),
    factor_type: t.Enum(MFAFactor),
    sms_otp_mobile_number: t.string,
    totp_factor_sid: t.string
});
